export default {
  setAlarm({ commit }, item) {
    commit('SET_ALARM', item)
  },

  clearAlarm({ commit }) {
    commit('CLEAR_ALARM')
  }
}